import React from 'react';

const KBIcon = ({ size = 28, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className}>
    <path d="M3 6C3 5 3.8 4 5 4h7c1.5 0 3 1 3 2.5V27c0-1.5-1.2-2.5-3-2.5H5c-1.2 0-2-1-2-2V6z" stroke="currentColor" strokeWidth="1.6" fill="none"/>
    <path d="M15 6.5C15 5 16.5 4 18 4h7c1.2 0 2 1 2 2v1" stroke="currentColor" strokeWidth="1.6" fill="none"/>
    <line x1="6" y1="9" x2="12" y2="9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
    <line x1="6" y1="12.5" x2="11" y2="12.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
    <line x1="6" y1="16" x2="10" y2="16" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
    <circle cx="22" cy="10" r="2" stroke="currentColor" strokeWidth="1.4" fill="none"/>
    <circle cx="27" cy="14" r="1.5" stroke="currentColor" strokeWidth="1.2" fill="none"/>
    <circle cx="21" cy="17" r="1.8" stroke="currentColor" strokeWidth="1.3" fill="none"/>
    <circle cx="26.5" cy="21" r="1.5" stroke="currentColor" strokeWidth="1.2" fill="none"/>
    <circle cx="20" cy="23" r="2" stroke="currentColor" strokeWidth="1.4" fill="none"/>
    <line x1="23.8" y1="11" x2="25.7" y2="13" stroke="currentColor" strokeWidth="1" opacity="0.6"/>
    <line x1="22" y1="12" x2="21.3" y2="15.2" stroke="currentColor" strokeWidth="1" opacity="0.6"/>
    <line x1="25.5" y1="14.8" x2="22.6" y2="16.5" stroke="currentColor" strokeWidth="1" opacity="0.6"/>
    <line x1="22.5" y1="18.2" x2="25.5" y2="19.8" stroke="currentColor" strokeWidth="1" opacity="0.6"/>
    <line x1="20.5" y1="18.8" x2="20.2" y2="21" stroke="currentColor" strokeWidth="1" opacity="0.6"/>
    <circle cx="22" cy="10" r="0.7" fill="currentColor" opacity="0.4"/>
    <circle cx="20" cy="23" r="0.7" fill="currentColor" opacity="0.4"/>
  </svg>
);

export default KBIcon;
